import { SchemaWithClient } from '../types/SchemaWithClient';
import { enumItems } from './enumItems';
import { NumberField } from '../components/Table/fields/NumberField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { userByRole } from './userByRole';
import {Client} from "../services/Client";

export const groupGuide: SchemaWithClient<any> = {
  name: 'Group Guide',
  pluralName: 'Group Guide',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },

  ],
  columns: {
    /*name: {
      name: 'Group Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },*/

    group: {
      name: 'Group',
      fieldRenderer: SPSelectField.tableAdapter(enumItems.group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.group),
      switchboard: true,
      url: '/groups/guide-status',
      tempSchema: enumItems.group,
      readOnly: true
    },
    guide: {
      name: 'Guide',
      fieldRenderer: SPSelectField.tableAdapter(userByRole('5')),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(userByRole('5')),
      switchboard: true,
      url: userByRole('5').client.getAllPath,
      tempSchema: userByRole('5'),
    },

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/groups/guide-status'),
};
